import { useEffect } from 'react';
import { makeStyles } from '@material-ui/styles';

import { Text, SadCat, MainButton } from '@bizzabo/design-system';

import useTypeTracking from '../../../analytics';

const ErrorPage = ({ resetErrorBoundary }) => {
    const classes = useStyles();

    const { trackSystemEvent } = useTypeTracking();

    useEffect(() => {
        trackSystemEvent({
            description: {
                action: 'ERROR_MESSAGE_LOADED',
            },
        });
    }, []);

    const onClose = () => {
        resetErrorBoundary();
    };

    return (
        <div className={classes.container}>
            <SadCat />
            <Text variant="t40" className={classes.title}>
                Something went wrong
            </Text>
            <Text variant="t61">please try again in a few minutes</Text>
            <MainButton className={classes.closeBtn} onClick={onClose}>
                Close
            </MainButton>
        </div>
    );
};

const useStyles = makeStyles(
    theme => ({
        container: {
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            paddingBottom: '10vh',
            [theme.breakpoints.up('sm')]: {
                paddingBottom: '30vh',
            },
        },
        title: {
            margin: '10px 0',
        },
        closeBtn: {
            ...theme.typography.t80,
            height: '24px',
            marginTop: 20,
        },
    }),
    { classNamePrefix: 'error-page-comp' }
);

export default ErrorPage;
